import { createSlice } from '@reduxjs/toolkit';
const InitialState = {
    autoReplyDetail: {},
};
const readMailSlice = createSlice({
    name: 'autoReplyReducer',
    initialState: InitialState,
    reducers: {
        updateAutoReplyDetail: (state, action) => {
            state.autoReplyDetail = action.payload;
        },
    },
});
export const { actions } = readMailSlice;
export default readMailSlice.reducer;
